export const ROUTE_OVERWATCH_USR_PROFILE = 'OD/ROUTE_OVERWATCH_USR_PROFILE'
export const ROUTE_OVERWATCH_ORG_PROFILE = 'OD/ROUTE_OVERWATCH_ORG_PROFILE'


export interface RouteOverwatchUsrProfileAction {
  readonly type: typeof ROUTE_OVERWATCH_USR_PROFILE;
}

export interface RouteOverwatchOrgProfileAction {
  readonly type: typeof ROUTE_OVERWATCH_ORG_PROFILE;
}


export const raiseRouteOverwatchUsrProfile = (): RouteOverwatchUsrProfileAction => ({
  type: ROUTE_OVERWATCH_USR_PROFILE,
})

export const raiseRouteOverwatchOrgProfile = (): RouteOverwatchOrgProfileAction => ({
  type: ROUTE_OVERWATCH_ORG_PROFILE,
})


